import { tableChartTransformation } from './charts';
import { DEFAULT_NAME, KEEN_KEY, KEEN_VALUE } from '../../constants';
export var transformSingular = function (_a, _settings, visualization) {
    var _b;
    var query = _a.query, result = _a.result;
    var value = result === null ? 0 : result;
    if ((query === null || query === void 0 ? void 0 : query.analysis_type) && (query === null || query === void 0 ? void 0 : query.event_collection) &&
        visualization === 'table') {
        return tableChartTransformation(query, value);
    }
    return {
        data: [(_b = {}, _b[KEEN_KEY] = DEFAULT_NAME, _b[KEEN_VALUE] = value, _b)],
        keys: [KEEN_VALUE],
    };
};
